import { createReducer } from 'Core/reducers/common.ts';
import { setServerRedirect } from 'Core/actions/response.ts';

const initState = null;

export default createReducer(
  {
    [setServerRedirect.type]: (_state, { payload }) => payload,
  },
  initState,
);
